import React from "react";
import { Pageheader } from "../../Constants/pageheader";
import { ResultNavigationHeader } from "../../Constants/Enums/navigationHeader.enum";
import Wrapper from "../../Components/Wrapper/wrapper";
import { useLocation } from "react-router-dom";
import { StudentResult } from "../../Components/ResultComponent/StudentResult/StudentResult";
import { ResultDetailsCard } from "../../Components/ResultComponent/ResultDetails/ResiltDetailsCard";

export const ResultDetailsPage = () => {
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);

  const defaultSection = ResultNavigationHeader.SUDENT_RESULT_DETAIL;
  const section = searchParams.get("section") || defaultSection;
  const resultId = searchParams.get("resultId") || "";
  const parsedResultId = parseInt(resultId, 10);

  if (!resultId) return <div></div>;

  return (
    <>
      <Wrapper
        header={Pageheader.ResultDetails}
        headerNavigation={[
          {
            text: "Student result details",
            section: ResultNavigationHeader.SUDENT_RESULT_DETAIL,
          },
        ]}
        headerComponent={<ResultDetailsCard resultId={parsedResultId} />}
      >
        {section === ResultNavigationHeader.SUDENT_RESULT_DETAIL ? (
          <StudentResult resultId={parsedResultId} />
        ) : (
          <></>
        )}
        <></>
      </Wrapper>
    </>
  );
};
